import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import 'assets/scss/userRewards.css';

import UserSurveyRewardApi from 'apis/UserSurveyReward';

import Toaster from 'components/Toaster';
import Loading from 'utils/Loading';
import RedeemVoucher from './RedeemVoucher';
import RedeemedVoucher from './RedeemedVoucher';

const LOCATION_DOES_NOT_MATCH = `Sorry! Location code doesn't match. Please try again!`;

class UserSurveyRewardLocation extends Component {
  constructor() {
    super();
    this.state = {
      couponCode: '',
      token: '',
      rewardId: '',
      userData: {},
      isLoading: false,
      businessId: '',
      businessName: '',
      locationCode: '',
      isTokenUsed: false,
      tokenErrorMessage: null,
      isLocationCodeValidated: false,
    };
  }

  componentDidMount() {
    this.onPageLoad();
  }

  onPageLoad = () => {
    const { location } = this.props;
    const { search } = location;

    if (!search) return;

    const values = qs.parse(search.substr(1));
    const tokenObj = `token=${values.token}`;

    this.setState({
      isLoading: true,
      token: values.token,
    });

    UserSurveyRewardApi.validateToken(tokenObj)
      .then(({ data }) => {
        this.setState({
          rewardId: data.id,
          couponCode: data.token,
          businessId: data.business_id,
          businessName: data.business_name,
          userData: data.user,
          isLoading: false,
        });
      })
      .catch(err => {
        this.setState({
          isTokenUsed: true,
          isLoading: false,
          tokenErrorMessage: err.response.data,
        });
      });
  };

  onLocationCodeChange = e => {
    this.setState({
      locationCode: e.target.value,
    });
  };

  verifyLocationCode = e => {
    e.preventDefault();

    const { locationCode, businessId } = this.state;
    if (!locationCode) return;

    const data = `location_code=${locationCode}`;

    UserSurveyRewardApi.validateLocationCode(businessId, data)
      .then(({ data }) => {
        if (data === LOCATION_DOES_NOT_MATCH) {
          Toaster.getFailureToaster('exclamation-triangle', data);
        }
        this.setState({
          isLocationCodeValidated: true,
        });
      })
      .catch(err => {
        Toaster.getErrorToaster('exclamation-triangle', 'Verification error.');
      });
  };

  reset = () => {
    this.setState({
      isTokenUsed: false,
      isLocationCodeValidated: false,
    });
    this.onPageLoad();
  };

  render() {
    const {
      isTokenUsed,
      isLocationCodeValidated,
      couponCode,
      locationCode,
      userData,
      rewardId,
      businessName,
      isLoading,
      tokenErrorMessage,
      token,
    } = this.state;

    if (isLoading) {
      return <Loading />;
    }

    if (isTokenUsed) {
      return <RedeemedVoucher message={tokenErrorMessage} token={token} />;
    }

    if (isLocationCodeValidated) {
      return (
        <RedeemVoucher
          user={userData}
          rewardId={rewardId}
          couponCode={couponCode}
          reset={this.reset}
          token={token}
        />
      );
    }

    return (
      <div className="container mt-3">
        <div className="col-md-6 mx-auto bg-white styled-box-shadow p-5">
          <div className="p-1 d-inline-block">
            <div className="d-inline-block">
              <h5 className="w-100 float-left text-center text-justify font-weight-bold">
                {businessName}
              </h5>
              <span className="w-100 mt-1 float-left text-center text-justify">
                Enter your location code to redeem this voucher.
              </span>
            </div>
            <div className="d-inline-block mt-2 w-100">
              <form className="mt-2">
                <input
                  name="location"
                  value={locationCode}
                  onChange={this.onLocationCodeChange}
                  className="form-control search-text height-4"
                  placeholder="Enter your Location Code"
                />
                <button
                  type="button"
                  className="w-100 mt-3 btn btn-add-new height-4"
                  onClick={this.verifyLocationCode}
                >
                  Continue
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UserSurveyRewardLocation.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default withRouter(UserSurveyRewardLocation);



// WEBPACK FOOTER //
// ./src/components/userSurveyReward/UserSurveyRewardLocation.js